import styled from 'astroturf/react'
import SimpleBar from 'simplebar-react'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const textColorLevel2 = 'var(--text-color-level2, rgba(26, 26, 26, 0.61))'
const textColorLevel3 = 'var(--text-color-level3, rgba(26, 26, 26, 0.1))'
const colorBgWhiteL1 = 'var(--color-bg-white-l-1, rgba(255, 255, 255, 1))'
const colorBgGrey2 = 'var(--color-bg-grey-2, #FAFAFA)'
const fontWeightBold = 'var(--fontWeightBold, 700)'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
const colorBackgroundWarning = 'var(--colorBackgroundWarning, var(--coreColorOrange200))'
const colorStrokeWarning = 'var(--colorStrokeWarning, var(--coreColorOrange600))'
import { BareButton } from '@calendly/ui/components/bare-button'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import _MutualAvailabilitySidebarWrapper from "styles-MutualAvailabilitySidebarWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/styles.js?styleId=MutualAvailabilitySidebarWrapper";
import _Panel from "styles-Panel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/styles.js?styleId=Panel";
import _Avatar from "styles-Avatar.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/styles.js?styleId=Avatar";
import _Header from "styles-Header.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/styles.js?styleId=Header";
import _ClickableHeader from "styles-ClickableHeader.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/styles.js?styleId=ClickableHeader";
import _InfoIconContainer from "styles-InfoIconContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/styles.js?styleId=InfoIconContainer";
import _Title from "styles-Title.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/styles.js?styleId=Title";
import _CalendarsLine from "styles-CalendarsLine.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/styles.js?styleId=CalendarsLine";
import _Content from "styles-Content.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/styles.js?styleId=Content";
import _ScrollContainer from "styles-ScrollContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/styles.js?styleId=ScrollContainer";
import _EmptyMessage from "styles-EmptyMessage.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/styles.js?styleId=EmptyMessage";
import _ErrorWarning from "styles-ErrorWarning.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/styles.js?styleId=ErrorWarning";
import _PretendEventWarning from "styles-PretendEventWarning.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/styles.js?styleId=PretendEventWarning";
import _Date from "styles-Date.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/styles.js?styleId=Date";


export const MutualAvailabilitySidebarWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "MutualAvailabilitySidebarWrapper",
  styles: _MutualAvailabilitySidebarWrapper
})

export const Panel = /*#__PURE__*/styled('div', null, {
  displayName: "Panel",
  styles: _Panel
})

export const Avatar = /*#__PURE__*/styled('img', null, {
  displayName: "Avatar",
  styles: _Avatar
})

const headerHeight = '76px'

export const Header = /*#__PURE__*/styled('div', null, {
  displayName: "Header",
  styles: _Header
})

export const ClickableHeader = /*#__PURE__*/styled(Header, null, {
  displayName: "ClickableHeader",
  styles: _ClickableHeader,
  attrs: props => ({
    ...props,
    as: BareButton
  })
})

export const InfoIconContainer = /*#__PURE__*/styled('div', null, {
  displayName: "InfoIconContainer",
  styles: _InfoIconContainer
})

export const Title = /*#__PURE__*/styled('div', null, {
  displayName: "Title",
  styles: _Title
})

export const CalendarsLine = /*#__PURE__*/styled('div', null, {
  displayName: "CalendarsLine",
  styles: _CalendarsLine
})

export const Content = /*#__PURE__*/styled('div', null, {
  displayName: "Content",
  styles: _Content,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const ScrollContainer = /*#__PURE__*/styled(SimpleBar, null, {
  displayName: "ScrollContainer",
  styles: _ScrollContainer
})

export const EmptyMessage = /*#__PURE__*/styled('div', null, {
  displayName: "EmptyMessage",
  styles: _EmptyMessage
})

export const ErrorWarning = /*#__PURE__*/styled('div', null, {
  displayName: "ErrorWarning",
  styles: _ErrorWarning
})

export const PretendEventWarning = /*#__PURE__*/styled('div', null, {
  displayName: "PretendEventWarning",
  styles: _PretendEventWarning
})

export const Date = /*#__PURE__*/styled('div', null, {
  displayName: "Date",
  styles: _Date
})
